import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'

@Component({
  selector: 'ngx-add-name-dialog',
  templateUrl: './add-name-dialog.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, MatRadioModule]
})
export class AddNameDialogComponent {
  protected readonly dialogRef = inject(MatDialogRef<AddNameDialogComponent>)
  protected readonly data = inject(MAT_DIALOG_DATA)
  protected readonly fb = inject(UntypedFormBuilder)

  addNameForm: UntypedFormGroup

  constructor() {
    this.addNameForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), this.noWhitespaceValidator, this.noSpecialCharactersValidator]],
      gender: ['Male', Validators.required]
    })
  }
  noWhitespaceValidator(control: UntypedFormControl) {
    const isWhitespace = (control.value || '').trim().length === 0
    const isValid = !isWhitespace
    return isValid ? null : { whitespace: true }
  }

  noSpecialCharactersValidator(control: UntypedFormControl) {
    const hasSpecialCharacters = /[^a-zA-Z ]/.test(control.value)
    const isValid = !hasSpecialCharacters
    return isValid ? null : { specialCharacters: true }
  }

  cancel(): void {
    this.dialogRef.close()
  }
}
